import axios from 'axios';
import {ICrudDeleteAction, ICrudGetAction, ICrudPutAction, IPayloadResult} from 'react-jhipster';

import {cleanEntity} from 'app/shared/util/entity-utils';
import {FAILURE, REQUEST, SUCCESS} from 'app/shared/reducers/action-type.util';

import {defaultValue, IJourney} from 'app/shared/model/journey.model';
import {IPayload} from 'react-jhipster/src/type/redux-action.type';

export const ACTION_TYPES = {
  FETCH_JOURNEY_LIST: 'journey/FETCH_JOURNEY_LIST',
  FETCH_JOURNEY: 'journey/FETCH_JOURNEY',
  CREATE_JOURNEY: 'journey/CREATE_JOURNEY',
  UPDATE_JOURNEY: 'journey/UPDATE_JOURNEY',
  DELETE_JOURNEY: 'journey/DELETE_JOURNEY',
  RESET: 'journey/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IJourney>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type JourneyState = Readonly<typeof initialState>;

// Reducer

export default (state: JourneyState = initialState, action): JourneyState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_JOURNEY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_JOURNEY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_JOURNEY):
    case REQUEST(ACTION_TYPES.UPDATE_JOURNEY):
    case REQUEST(ACTION_TYPES.DELETE_JOURNEY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_JOURNEY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_JOURNEY):
    case FAILURE(ACTION_TYPES.CREATE_JOURNEY):
    case FAILURE(ACTION_TYPES.UPDATE_JOURNEY):
    case FAILURE(ACTION_TYPES.DELETE_JOURNEY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_JOURNEY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_JOURNEY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_JOURNEY):
    case SUCCESS(ACTION_TYPES.UPDATE_JOURNEY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_JOURNEY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/journeys';

// Actions

export const getEntities: (
  activeOnly?: boolean,
  countryId?: string,
  patientCaseId?: string,
  page?: number,
  size?: number,
  sort?: string
) => IPayload<IJourney> | IPayloadResult<IJourney> = (activeOnly?: boolean, countryId?: string, patientCaseId?: string, page?: number, size?: number, sort?: string) => {
  const requestUrl = `${apiUrl}?${
    activeOnly ? 'activeOnly=true&' : ''
  }${
    countryId ? `countryId=${countryId}&` : ''
  }${
    patientCaseId ? `patientCaseId=${patientCaseId}&` : ''
  }${
    page ? `page=${page}&` : ''
  }${
    size ? `size=${size}&` : ''
  }${
    sort ? `sort=${sort}` : '&'
  }cacheBuster=${new Date().getTime()}`;

  return {
    type: ACTION_TYPES.FETCH_JOURNEY_LIST,
    payload: axios.get<IJourney>(requestUrl),
  };
};

export const getEntity: ICrudGetAction<IJourney> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_JOURNEY,
    payload: axios.get<IJourney>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IJourney> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_JOURNEY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IJourney> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_JOURNEY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const partialUpdateEntity: (journeyId: string, updateData: IJourney) => IPayload<IJourney> | IPayloadResult<IJourney> = (journeyId, updateData) => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.UPDATE_JOURNEY,
    payload: axios.put(`${apiUrl}/${journeyId}`, cleanEntity(updateData)),
  });
}

export const deleteEntity: ICrudDeleteAction<IJourney> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_JOURNEY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => dispatch => {
  return dispatch({
    type: ACTION_TYPES.RESET
  });
};
